import { useFeatureFlag } from '@artic/ui/feature-flags';
import { createFileRoute } from '@tanstack/react-router';

import { ImportDetail } from '../../features/imports/import-detail';
import { importDetailQueryOptions } from '../../features/imports/queries';
import { usePartnerId } from '../../features/inbox/use-partner-name';

export const Route = createFileRoute('/imports/$importId')({
  staticData: {
    breadcrumb: 'Import',
    layout: 'default',
  },
  loader: ({ context: { queryClient }, params: { importId } }) =>
    queryClient.ensureQueryData(importDetailQueryOptions(importId)),
  pendingComponent: () => (
    <div className="p-6">
      <p className="text-muted-foreground text-sm">Loading import…</p>
    </div>
  ),
  errorComponent: ({ error }) => (
    <div className="p-6">
      <p className="text-destructive text-sm">
        Failed to load import: {error instanceof Error ? error.message : 'Unknown error'}
      </p>
    </div>
  ),
  component: ImportDetailPage,
});

function ImportDetailPage() {
  const { importId } = Route.useParams();
  const enabled = useFeatureFlag('imports');
  const partnerId = usePartnerId();

  if (!enabled) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-20">
        <h2 className="text-lg font-semibold">Imports is not available</h2>
        <p className="text-muted-foreground text-sm">
          Imports is not enabled for your organisation.
        </p>
      </div>
    );
  }

  return <ImportDetail importId={importId} partnerId={partnerId} />;
}
